import { useEffect, useMemo, useState } from "react";

import { useNode } from "@craftjs/core";

import createContextFactory from "@/utils/factory";

const { Provider, useContext } = createContextFactory(({ definition, getParentId }) => {
  const parent = useParent(getParentId)

  return useMemo(() => ({
    parent,
    definition,
  }), [definition, parent])
})

/**
 * @param {() => string} getParentId
 */

function useParent(getParentId) {
  const { id } = useNode()
  const [isValidParent, setIsValidParent] = useState(false)

  return useMemo(() => ({
    setIsValidParent,
    getId: () => isValidParent ? id : getParentId?.() ?? null,
    getParentId,
  }), [id, isValidParent, getParentId])
}

export function DefinitionProvider({ children, ...props }) {
  const { parent: { getId } = {} } = useContext()

  return <Provider getParentId={getId} {...props}>
    {children}
  </Provider>
}

export function useCloseParent() {
  const { parent: { setIsValidParent, getParentId } } = useContext()

  useEffect(() => {
    setIsValidParent(true)
  }, [setIsValidParent])

  return getParentId()
}
